<template>
  <div class="form_item">
    <div>
      <Label v-if="displayLabel" :required="required" :label="label" :for_id="save_to"/>
      <select
        :id="save_to"
        :name="validationLabel || label"
        :key="save_to"
        :value="val"
        @change="onChange"
        :required="required"
        :v-validate="rules"
        :autocomplete="autocomplete"
        :class="{'has-error': errors.has(label)}"
      >
        <option v-if="defaultOptionText !== undefined" :value="defaultOptionText.toLowerCase()">{{defaultOptionText}}</option>
        <option v-for="(option, index) in options" :value="(option.value !== undefined) ? option.value : option.toLowerCase()" :key="index">{{option.value !== undefined ? option.name : option}}</option>
      </select>
    </div>
    <div class="form_item form_item_select" :class="save_to+'_wrapper'" v-if="selectedOption && selectedOption.other">
      <div :id="save_to+'_element'">
        <Label :required="false" label="Précisez" :for_id="save_to"/>
        <input
          id="precisez"
          type="text"
          name="précisez"
          :required="false"
          :value="other"
          @input="inputOther"
        />
      </div>
    </div>
    <p v-if="info !== undefined" class="info" v-html="info"></p>
    <span class="error" v-show="errors.has(validationLabel || label)">{{ errors.first(validationLabel || label) }}</span>
  </div>
</template>

<script>
import { validatorComponent } from './validatorComponentMixin';

export default {
  name: 'Select',
  mixins: [validatorComponent],
  data: function() {
    return {
      selectedOption: undefined,
      other: '',
    }
  },
  props: {
    save_to: String,
    defaultOptionText: {
      type: String
    },
    validationLabel: String,
    displayLabel: {
      type: Boolean,
      default: true,
    },
    unique: Boolean,
    operationId: String,
    autocomplete: String,
    options: {
      type: Array,
      required: true
    }
  },
  created() {
    if(this.defaultOptionText) {
      this.val = this.defaultOptionText.toLowerCase();
    }
  },
  computed: {
    rules() {
      let unique = false;
      if(this.unique) {
        unique = [this.save_to, this.operationId]
      }
      return {
        required: this.required,
        unique
      }
    }
  },
  methods: {
    onChange($event) {
      for (let i = 0; i < this.options.length; i++) {
        const option = this.options[i];
        if(option.value == $event.target.value || (option.value === undefined && option.toLowerCase() == $event.target.value)) {
          this.selectedOption = option;
          break;
        }
      }
      if(this.selectedOption.other) {
        this.$emit('input', $event.target.value + ':' + this.other)
      } else {
        this.$emit('input', $event.target.value)
      }
      this.val = $event.target.value;
    },
    inputOther($event) {
      let value = (this.selectedOption.value !== undefined) ? this.selectedOption.value : this.selectedOption.toLowerCase()
      this.$emit('input', value + ':' + $event.target.value)
    }
  },
};
</script>
